export const AwakenedKingdomAddress = '0x8D1960a7A414031aCd2bf54eE469b834f113816f'
